const HeadingsToc = (label) => {
  let heading = [];
  switch (label) {
    case 'about-us':
      heading = [
        {
          url: "We're Different with Multi Brand",
          title: 'We’re Different with Multi Brand',
        },
        {
          url: 'Our Features',
          title: 'Our Features',
        },
      ];
      break;
    case 'design-getting-started-internal':
      heading = [
        {
          url: 'Internal Design Library',
          title: 'Internal Design Library',
        },
        {
          url: 'Access Request',
          title: 'Access Request',
        },
        {
          url: 'Design Library Ecosystem And Tribe',
          title: 'Design Library Ecosystem & Tribe',
        },
      ];
      break;
    case 'design-getting-started-external':
      heading = [
        {
          url: 'Community Design Library',
          title: 'Community Design Library',
        },
        {
          url: 'Usage Library',
          title: 'Usage Library',
        },
      ];
      break;
    case 'design-project-setup':
      heading = [
        {
          url: 'Project Structure',
          title: 'Project Structure',
        },
        {
          url: 'Project Naming',
          title: 'Project Naming',
        },
        {
          url: 'Folder Naming',
          title: 'Folder Naming',
        },
        {
          url: 'Design System Folder',
          title: 'Design System Folder',
        },
        {
          url: 'File Structure',
          title: 'File Structure',
        },
        {
          url: 'File Name and Thumbnail',
          title: 'File Name & Thumbnail',
        },
      ];
      break;
    case 'design-guideline-flow':
      heading = [
        {
          url: 'Usage Annotation',
          title: 'Usage Annotation',
        },
        {
          url: 'Pluggin Recomendation',
          title: 'Pluggin Recomendation',
        },
      ];
      break;
    case 'design-guideline-screen':
      heading = [
        {
          url: 'Usage Library',
          title: 'Usage Library',
        },
        {
          url: 'Template And Others Library',
          title: 'Template & Others Library',
        },
        {
          url: 'Pluggin Recomendation',
          title: 'Pluggin Recomendation',
        },
      ];
      break;
    case 'development-installation-android':
      heading = [
        {
          url: 'Prequisites',
          title: 'Prequisites',
        },
        {
          url: 'Installation',
          title: 'Installation',
        },
      ];
      break;
    case 'development-installation-website':
      heading = [
        {
          url: 'Prequisites',
          title: 'Prequisites',
        },
        {
          url: 'Installation',
          title: 'Installation',
        },
      ];
      break;
    case 'development-installation-ios':
      heading = [
        {
          url: 'Prequisites',
          title: 'Prequisites',
        },
        {
          url: 'Installation',
          title: 'Installation',
        },
        {
          url: 'Step',
          title: 'Step',
        },
        {
          url: 'Theme',
          title: 'Theme',
        },
        {
          subMenu: true,
          url: 'Setup',
          title: 'Setup',
        },
      ];
      break;
    case 'development-configuration-android':
      heading = [
        {
          url: 'Multi-Theme',
          title: 'Multi-Theme',
        },
        {
          url: 'Available Themes',
          title: 'Available Themes',
        },
        {
          url: 'Apply Prebuild Theme',
          title: 'Apply Prebuild Theme',
        },
        {
          url: 'Customize Themes',
          title: 'Customize Themes',
        },
      ];
      break;
    case 'development-configuration-website':
      heading = [
        {
          url: 'Multi-Theme',
          title: 'Multi-Theme',
        },
        {
          url: 'ThemeProvider',
          title: 'ThemeProvider',
        },
        {
          url: 'Props',
          title: 'Props',
        },
        {
          url: 'Available Themes',
          title: 'Available Themes',
        },
        {
          url: 'Installing Fonts Theme',
          title: 'Installing Fonts Theme',
        },
        {
          url: 'Usage Themes',
          title: 'Usage Themes',
        },
      ];
      break;
    case 'development-configuration-ios':
      heading = [
        {
          url: 'Import Theme',
          title: 'Import Theme',
        },
        {
          url: 'Step',
          title: 'Step',
        },
      ];
      break;
    case 'foundation-accessibility':
      heading = [
        {
          url: 'What is Accessibility',
          title: 'What is Accessibility?',
        },
        {
          url: 'Resources',
          title: 'Resources',
        },
      ];
      break;
    case 'foundation-color-system-ios':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          subMenu: true,
          url: 'Default LegionUI',
          title: 'Default LegionUI',
        },
        {
          subMenu: true,
          url: 'Theme',
          title: 'Theme',
        },
        {
          url: 'Primary Colors',
          title: 'Primary Colors',
        },
        {
          subMenu: true,
          url: 'Primary Colors Default LegionUI',
          title: 'Primary Color Default LegionUI',
        },
        {
          subMenu: true,
          url: 'Primary Colors Theme',
          title: 'Primary Colors Theme',
        },
        {
          url: 'Secondary Colors',
          title: 'Secondary Colors',
        },
        {
          subMenu: true,
          url: 'Secondary Colors Default LegionUI',
          title: 'Secondary Colors Default LegionUI',
        },
        {
          subMenu: true,
          url: 'Secondary Colors Theme',
          title: 'Secondary Colors Theme',
        },
        {
          url: 'Tertiary Colors',
          title: 'Tertiary Colors',
        },
        {
          subMenu: true,
          url: 'Tertiary Colors Default LegionUI',
          title: 'Tertiary Colors Default LegionUI',
        },
        {
          subMenu: true,
          url: 'Tertiary Colors Theme',
          title: 'Tertiary Colors Theme',
        },
        {
          url: 'Semantic Colors',
          title: 'Semantic Colors',
        },
        {
          url: 'Success',
          title: 'Success',
        },
        {
          subMenu: true,
          url: 'Success Colors Default LegionUI',
          title: 'Success Colors - Default LegionUI',
        },
        {
          subMenu: true,
          url: 'Success Colors Theme',
          title: 'Success Colors Theme',
        },
        {
          url: 'Warning',
          title: 'Warning',
        },
        {
          subMenu: true,
          url: 'Warning Colors Default LegionUI',
          title: 'Warning Colors Default LegionUI',
        },
        {
          subMenu: true,
          url: 'Warning Colors Theme',
          title: 'Warning Colors Theme',
        },
        {
          url: 'Information',
          title: 'Information',
        },
        {
          subMenu: true,
          url: 'Information Colors Default LegionUI',
          title: 'Information Colors Default LegionUI',
        },
        {
          subMenu: true,
          url: 'Information Colors Theme',
          title: 'Information Colors Theme',
        },
        {
          url: 'Error',
          title: 'Error',
        },
        {
          subMenu: true,
          url: 'Error Colors Default LegionUI',
          title: 'Error Colors Default LegionUI',
        },
        {
          subMenu: true,
          url: 'Error Colors Theme',
          title: 'Error Colors Theme',
        },
      ];
      break;
      case 'foundation-color-system-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Color Primary',
          title: 'Color Primary',
        },
        {
          url: 'Color Secondary',
          title: 'Color Secondary',
        },
        {
          url: 'Color Tertiary',
          title: 'Color Tertiary',
        },
        {
          url: 'Color Accent',
          title: 'Color Accent',
        },
      ];
      break;
    case 'foundation-color-system-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variants',
          title: 'Variants',
        },
        {
          subMenu: true,
          url: 'Color Primary',
          title: 'Color Primary',
        },
        {
          subMenu: true,
          url: 'Color Secondary',
          title: 'Color Secondary',
        },
        {
          subMenu: true,
          url: 'Color Tertiary',
          title: 'Color Tertiary',
        },
        {
          subMenu: true,
          url: 'Color Accent',
          title: 'Color Accent',
        },
        {
          url: 'Example',
          title: 'Example',
        }
      ];
      break;
    case 'foundation-color-system-guideline':
      heading = [
        {
          url: 'Getting Colors Right',
          title: 'Getting Colors Right',
        },
        {
          url: 'Defining your color palette',
          title: 'Defining your color palette',
        },
        {
          url: 'Primary Colors',
          title: 'Primary Colors',
        },
        {
          url: 'Secondary Palette',
          title: 'Secondary Palette',
        },
        {
          url: 'Tertiary Palette',
          title: 'Tertiary Palette',
        },
        {
          url: 'Accent Colors',
          title: 'Accent Colors',
        },
      ];
      break;
    case 'foundation-typography-website':
      heading = [
        {
          url: 'Heading',
          title: 'Heading',
        },
        {
          url: 'Body',
          title: 'Body',
        },
        {
          url: 'Caption',
          title: 'Caption',
        },
        {
          url: 'Responsive',
          title: 'Responsive',
        },
        {
          url: 'Color',
          title: 'Color',
        },
      ];
      break;
    case 'foundation-typography-android':
      heading = [
        {
          url: 'Heading',
          title: 'Heading',
        },
        {
          url: 'Body',
          title: 'Body',
        },
        {
          url: 'Caption',
          title: 'Caption',
        },
      ];
      break;
    case 'foundation-typography-guideline':
      heading = [
        {
          url: 'Why Typography Matters',
          title: 'Why Typography Matters?',
        },
        {
          url: 'Defining your typography',
          title: 'Defining your typography',
        },
        {
          url: 'Typography rules',
          title: 'Typography rules',
        },
      ];
      break;
    case 'foundation-spacer-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Preview',
          title: 'Preview',
        },
      ];
      break;
    case 'foundation-spacer-android':
      heading = [
        {
          url: 'Preview',
          title: 'Preview',
        },
      ];
      break;
    case 'foundation-spacer-guideline':
      heading = [
        {
          url: 'Why Spacers Matter',
          title: 'Why Spacers Matter?',
        },
        {
          url: 'Spacing units',
          title: 'Spacing units',
        },
        {
          url: 'Platform spesific',
          title: 'Platform spesific',
        },
        {
          url: 'Spacer Type',
          title: 'Spacer Type',
        },
        {
          url: 'Inline spacing',
          title: 'Inline spacing',
        },
        {
          url: 'Stack spacing',
          title: 'Stack spacing',
        },
      ];
      break;
    case 'foundation-radius-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Preview',
          title: 'Preview',
        },
      ];
      break;
    case 'foundation-radius-android':
      heading = [
        {
          url: 'Preview',
          title: 'Preview',
        },
      ];
      break;
    case 'foundation-radius-guideline':
      heading = [
        {
          url: 'Why Radius Matter',
          title: 'Why Radius Matter?',
        },
        {
          url: 'Spacing units',
          title: 'Spacing units',
        },
        {
          url: 'Platform spesific',
          title: 'Platform spesific',
        },
        {
          url: 'Spacer Type',
          title: 'Spacer Type',
        },
        {
          url: 'Inline spacing',
          title: 'Inline spacing',
        },
        {
          url: 'Stack spacing',
          title: 'Stack spacing',
        },
      ];
      break;
    case 'foundation-elevation-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Preview',
          title: 'Preview',
        },
      ];
      break;
    case 'foundation-elevation-android':
      heading = [
        {
          url: 'Preview',
          title: 'Preview',
        },
      ];
      break;
    case 'foundation-elevation-guideline':
      heading = [
        {
          url: 'Why Elevation Matter',
          title: 'Why Elevation Matter?',
        },
        {
          url: 'Spacing units',
          title: 'Spacing units',
        },
        {
          url: 'Platform spesific',
          title: 'Platform spesific',
        },
        {
          url: 'Spacer Type',
          title: 'Spacer Type',
        },
        {
          url: 'Inline spacing',
          title: 'Inline spacing',
        },
        {
          url: 'Stack spacing',
          title: 'Stack spacing',
        },
      ];
      break;
    case 'components-anchor-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Basic',
          title: 'Basic',
          subMenu: true,
        },
        {
          url: 'Icons',
          title: 'Icons',
          subMenu: true,
        },
        {
          url: 'Disabled',
          title: 'Disabled',
          subMenu: true,
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          url: 'Size',
          title: 'Size',
          subMenu: true,
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-anchor-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Large Size',
          title: 'Large Size',
        },
        {
          subMenu: true,
          url: 'Small Size',
          title: 'Small Size',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
      ];
      break;
    case 'components-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-avatar-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Basic',
          title: 'Basic',
          subMenu: true,
        },
        {
          url: 'Additional badge',
          title: 'Additional badge',
          subMenu: true,
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          url: 'Size',
          title: 'Size',
          subMenu: true,
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-avatar-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-badge-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Bordered',
          title: 'Bordered',
          subMenu: true,
        },
        {
          url: 'As Additionals',
          title: 'As Additionals',
          subMenu: true,
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          url: 'Size',
          title: 'Size',
          subMenu: true,
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-badge-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-button-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Color',
          title: 'Color',
        },
        {
          url: 'Size',
          title: 'Size',
        },
        {
          url: 'Icons',
          title: 'Icons',
        },
        {
          url: 'Disabled',
          title: 'Disabled',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-button-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Fill Button',
          title: 'Fill Button',
        },
        {
          subMenu: true,
          url: 'Outline Button',
          title: 'Outline Button',
        },
        {
          subMenu: true,
          url: 'Ghost Button',
          title: 'Ghost Button',
        },
        {
          subMenu: true,
          url: 'Transparent Button',
          title: 'Transparent Button',
        },
        {
          subMenu: true,
          url: 'Theming Button',
          title: 'Theming Button',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
        {
          subMenu: true,
          url: 'Attributes',
          title: 'Attributes',
        },
        {
          url: 'Example',
          title: 'Example',
        },
      ];
      break;
    case 'components-divider-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-spinner-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Basic',
          title: 'Basic',
        },
        {
          url: 'Inside a Container',
          title: 'Inside a Container',
        },
        {
          url: 'Size',
          title: 'Size',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-spinner-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
      ];
      break;
    case 'components-spinner-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-switch-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Basic',
          title: 'Basic',
        },
        {
          subMenu: true,
          url: 'Label',
          title: 'Label',
        },
        {
          subMenu: true,
          url: 'Disabled',
          title: 'Disabled',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-switch-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
      ];
      break;
    case 'components-textarea-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-textfield-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Basic',
          title: 'Basic',
        },
        {
          subMenu: true,
          url: 'Label',
          title: 'Label',
        },
        {
          subMenu: true,
          url: 'Disabled',
          title: 'Disabled',
        },
        {
          subMenu: true,
          url: 'Error',
          title: 'Error',
        },
        {
          subMenu: true,
          url: 'Caption',
          title: 'Caption',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-textfield-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Basic',
          title: 'Basic',
        },
        {
          url: 'Icon',
          title: 'Icon',
        },
        {
          url: 'prefix-and-suffix',
          title: 'Prefix & Suffix',
        },
        {
          url: 'Disabled',
          title: 'Disabled',
        },
        {
          url: 'Error',
          title: 'Error',
        },
        {
          url: 'Success',
          title: 'Success',
        },
        {
          url: 'Password Field',
          title: 'Password Field',
        },
        {
          url: 'Date Field',
          title: 'Date Field',
        },
        {
          url: 'Time Field',
          title: 'Time Field',
        },
        {
          url: 'Dropdown Field',
          title: 'Dropdown Field',
        },
        {
          url: 'Unit Field',
          title: 'Unit Field',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
      ];
      break;
    case 'components-textfield-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-tooltip-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Title',
          title: 'Title',
        },
        {
          subMenu: true,
          url: 'Placement',
          title: 'Placement',
        },
        {
          subMenu: true,
          url: 'Not Arrow',
          title: 'Not Arrow',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-tooltip-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'pattern-loginandregister-website':
      heading = [
        {
          url: 'Case : Mobile Number as Primary Key',
          title: 'Mobile Number as Primary Key',
        },
        {
          url: 'Case : Username as Primary Key',
          title: 'Username as Primary Key',
        },
        {
          url: 'Case : Email Address as Primary Key',
          title: 'Email Address as Primary Key',
        },
        {
          url: 'Case : Telkom (NIK) as Primary Key',
          title: 'Telkom (NIK) as Primary Key',
        },
        {
          url: 'Case : Third Party (SSO) as Primary Key',
          title: 'Third Party (SSO) as Primary Key',
        },
      ];
      break;
    case 'pattern-loginandregister-mobile':
      heading = [
        {
          url: 'Case : Mobile Number as Primary Key',
          title: 'Mobile Number as Primary Key',
        },
        {
          url: 'Case : Username as Primary Key',
          title: 'Username as Primary Key',
        },
        {
          url: 'Case : Email Address as Primary Key',
          title: 'Email Address as Primary Key',
        },
        {
          url: 'Case : Telkom (NIK) as Primary Key',
          title: 'Telkom (NIK) as Primary Key',
        },
        {
          url: 'Case : Third Party (SSO) as Primary Key',
          title: 'Third Party (SSO) as Primary Key',
        },
      ];
      break;
    case 'pattern-onboarding-website':
      heading = [
        {
          url: 'Yaml data',
          title: 'Yaml data',
        },
        {
          url: 'Adding a divider',
          title: 'Adding a divider',
        },
        {
          url: 'Customizing',
          title: 'Customizing',
        },
      ];
      break;
    case 'pattern-onboarding-mobile':
      heading = [
        {
          url: 'Case : Content is Mandatory',
          title: 'Content is Mandatory?',
        },
        {
          url: 'Case : Content is Optional',
          title: 'Content is Optional',
        },
        {
          url: 'Case : Without Content',
          title: 'Without Content',
        },
      ];
      break;
    case 'content-writing-experience':
      heading = [
        {
          url: 'Button Call to Action',
          title: 'Button / Call to action',
        },
        {
          url: 'Empty States',
          title: 'Empty States',
        },
        {
          url: 'Error Messages',
          title: 'Error Messages',
        },
        {
          url: 'Success Messages',
          title: 'Success Messages',
        },
        {
          url: 'Placeholders',
          title: 'Placeholders',
        },
        {
          url: 'Labels',
          title: 'Labels',
        },
        {
          url: 'Notifications',
          title: 'Notifications',
        },
      ];
      break;
    case 'content-guideline':
      heading = [
        {
          url: 'Guideline Usage',
          title: 'Guideline Usage',
        },
        {
          url: 'Writing Principles',
          title: 'Writing Principles',
        },
      ];
      break;
    case 'release-notes':
      heading = [
        {
          url: 'Latest Release',
          title: 'Latest Release',
        },
        {
          url: 'Website Updates',
          title: 'Website Updates',
        },
        {
          url: 'Development Library Updates',
          title: 'Development Library Updates',
        },
        {
          url: 'Design Library Updates',
          title: 'Design Library Updates',
        },
        {
          url: 'Previous Release',
          title: 'Previous Release',
        },
      ];
      break;
    case 'components-snackbar-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-snackbar-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Basic Usage',
          title: 'Basic Usage',
        },
        {
          url: 'Advanced Usage',
          title: 'Advanced Usage',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
      ];
      break;
    case 'components-card-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Hoverable',
          title: 'Hoverable',
        },
        {
          url: 'Example',
          title: 'Example',
        },
      ];
      break;
    case 'components-switch-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-textarea-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Basic',
          title: 'Basic',
        },
        {
          subMenu: true,
          url: 'Label',
          title: 'Label',
        },
        {
          subMenu: true,
          url: 'Disabled',
          title: 'Disabled',
        },
        {
          subMenu: true,
          url: 'Error',
          title: 'Error',
        },
        {
          subMenu: true,
          url: 'Caption',
          title: 'Caption',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-textarea-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Basic',
          title: 'Basic',
        },
        {
          url: 'Required Text Area',
          title: 'Required Text Area',
        },
        {
          url: 'Optional Text Area',
          title: 'Optional Text Area',
        },
        {
          url: 'Disabled Text Area',
          title: 'Disabled Text Area',
        },
        {
          url: 'Error Indicator Text Area',
          title: 'Error Indicator Text Area',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
      ];
      break;
    case 'components-accordion-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
        {
          url: 'Example',
          title: 'Example',
        },
      ];
      break;
    case 'components-button-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-checkbox-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-checkbox-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          subMenu: true,
          url: 'Base Components',
          title: 'Base Components',
        },
        {
          subMenu: true,
          url: 'Checkbox Group',
          title: 'Checkbox Group',
        },
        {
          subMenu: true,
          url: 'Checkbox Container',
          title: 'Checkbox Container',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Primary Color Checkbox',
          title: 'Primary Color Checkbox',
        },
        {
          subMenu: true,
          url: 'Secondary Color Checkbox',
          title: 'Secondary Color Checkbox',
        },
        {
          subMenu: true,
          url: 'Primary Color Checkbox Group',
          title: 'Primary Color Checkbox Group',
        },
        {
          subMenu: true,
          url: 'Secondary Color Checkbox Group',
          title: 'Secondary Color Checkbox Group',
        },
        {
          subMenu: true,
          url: 'Primary Color Checkbox Container',
          title: 'Primary Color Checkbox Container',
        },
        {
          subMenu: true,
          url: 'Secondary Color Checkbox Container',
          title: 'Secondary Color Checkbox Container',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
        {
          subMenu: true,
          url: 'Base Component Attributes',
          title: 'Base Component Attributes',
        },
        {
          subMenu: true,
          url: 'Checkbox Group Attributes',
          title: 'Checkbox Group Attributes',
        },
        {
          subMenu: true,
          url: 'Checkbox Container Attributes',
          title: 'Checkbox Container Attributes',
        },
      ];
      break;
    case 'components-checkbox-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Accessibility',
          title: 'Accessibility',
        },
        {
          url: 'Content',
          title: 'Content',
        },
      ];
      break;
    case 'components-divider-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Basic',
          title: 'Basic',
        },
        {
          url: 'Split it',
          title: 'Split it',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-divider-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Basic',
          title: 'Basic',
        },
        {
          url: 'Intergrate with RecyclerView',
          title: 'Intergrate with RecyclerView',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
      ];
      break;
    case 'contribute-and-request':
      heading = [
        {
          url: 'A Guide on How to Contribute',
          title: 'A Guide on How to Contribute',
        },
      ];
      break;
    case 'release-notes-mobile':
      heading = [
        {
          url: 'Latest Release',
          title: 'Latest Release',
        },
        {
          url: 'Development Library Updates',
          title: 'Development Library Updates',
        },
        {
          url: 'Design Library Updates',
          title: 'Design Library Updates',
        },
        {
          url: 'Previous Release',
          title: 'Previous Release',
        },
      ];
      break;
    case 'components-card-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'accessibility',
          title: 'accessibility',
        },
        {
          url: 'content',
          title: 'content',
        },
      ];
      break;
    case 'components-table-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Basic Table',
          title: 'Basic Table',
        },
        {
          url: 'Data Table',
          title: 'Data Table',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-table-guideline':
      heading = [
        {
          url: 'Anatomy',
          title: 'Anatomy',
        },
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'accessibility',
          title: 'Accessibility',
        },
        {
          url: 'content',
          title: 'Content',
        },
      ];
      break;
    case 'components-select-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Basic Select',
          title: 'Basic Select',
        },
        {
          subMenu: true,
          url: 'Disabled',
          title: 'Disabled',
        },
        {
          subMenu: true,
          url: 'Icon',
          title: 'Icon',
        },
        {
          subMenu: true,
          url: 'Label and Caption',
          title: 'Label and Caption',
        },
        {
          subMenu: true,
          url: 'Multi Select',
          title: 'Multi Select',
        },
        {
          subMenu: true,
          url: 'Show Select Option',
          title: 'Show Select Option',
        },
        {
          subMenu: true,
          url: 'Open Menu onSelect',
          title: 'Open Menu onSelect',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-navigation-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Basic Navigation Bar',
          title: 'Basic Navigation Bar',
        },
        {
          subMenu: true,
          url: 'Navigation with Menu',
          title: 'Navigation with Menu',
        },
        {
          subMenu: true,
          url: 'Navigation with Search',
          title: 'Navigation with Search',
        },
        {
          subMenu: true,
          url: 'Navigation with Avatar',
          title: 'Navigation with Avatar',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-accordion-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Accordion with Left Icon',
          title: 'with Left Icon',
          subMenu: true,
        },
        {
          url: 'Accordion without Icon',
          title: 'without Icon',
          subMenu: true,
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-sidebar-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Basic',
          title: 'Basic',
        },
        {
          subMenu: true,
          url: 'With Sub Menu',
          title: 'With Sub Menu',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-ios':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Type',
          title: 'Type',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
      ];
      break;
    case 'components-basic-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
      ];
      break;
    case 'components-basic-with-props-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-ios-snackbar':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Step',
          title: 'Step',
        },
        {
          subMenu: true,
          url: 'Step 1',
          title: 'Step 1',
        },
        {
          subMenu: true,
          url: 'Step 2',
          title: 'Step 2',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Description',
          title: 'Description',
        },
        {
          subMenu: true,
          url: 'Avatar',
          title: 'Avatar',
        },
        {
          subMenu: true,
          url: 'Icon',
          title: 'Icon',
        },
        {
          subMenu: true,
          url: 'Button Text',
          title: 'Button Text',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
        {
          url: 'Example Project',
          title: 'Example Project',
        },
        {
          url: 'Important Notes',
          title: 'Important Notes',
        },
      ];
      break;
    case 'components-ios-checkbox':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          subMenu: true,
          url: 'Disable',
          title: 'Disable',
        },
        {
          subMenu: true,
          url: 'Label',
          title: 'Label',
        },
        {
          subMenu: true,
          url: 'Mixed',
          title: 'Mixed',
        },
        {
          subMenu: true,
          url: 'Font Label',
          title: 'Font Label',
        },
        {
          subMenu: true,
          url: 'Border',
          title: 'Border',
        },
        {
          subMenu: true,
          url: 'Background',
          title: 'Background',
        },
        {
          subMenu: true,
          url: 'Line Color',
          title: 'Line Color',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
      ];
      break;
    case 'components-ios-avatar':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Avatar Image',
          title: 'Avatar Image',
        },
        {
          subMenu: true,
          url: 'Avatar Icon',
          title: 'Avatar Icon',
        },
        {
          subMenu: true,
          url: 'Avatar Initial',
          title: 'Avatar Initial',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          subMenu: true,
          url: 'Ratio',
          title: 'Ratio',
        },
        {
          subMenu: true,
          url: 'Show Progress',
          title: 'Show Progress',
        },
        {
          url: 'Example Project',
          title: 'Example Project',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
        {
          subMenu: true,
          url: 'LGNAvatarImage',
          title: 'LGNAvatarImage',
        },
        {
          subMenu: true,
          url: 'LGNAvatarIcon',
          title: 'LGNAvatarIcon',
        },
        {
          subMenu: true,
          url: 'LGNAvatarInitials',
          title: 'LGNAvatarInitials',
        },
      ];
      break;
    case 'components-ios-button':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          subMenu: true,
          url: 'Responsive',
          title: 'Responsive',
        },
        {
          subMenu: true,
          url: 'Icon',
          title: 'Icon',
        },
        {
          subMenu: true,
          url: 'Show Activity',
          title: 'Show Activity',
        },
        {
          subMenu: true,
          url: 'Disable',
          title: 'Disable',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
      ];
      break;
    case 'components-ios-radiobutton':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          subMenu: true,
          url: 'Disable',
          title: 'Disable',
        },
        {
          subMenu: true,
          url: 'Label',
          title: 'Label',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
        {
          url: 'Example Project',
          title: 'Example Project',
        },
      ];
      break;
    case 'components-ios-switch':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          subMenu: true,
          url: 'Disable',
          title: 'Disable',
        },
        {
          subMenu: true,
          url: 'Label',
          title: 'Label',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
        {
          url: 'Example Project',
          title: 'Example Project',
        },
      ];
      break;
    case 'components-ios-textarea':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Outline',
          title: 'Outline',
        },
        {
          subMenu: true,
          url: 'Inline',
          title: 'Inline',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Disable',
          title: 'Disable',
        },
        {
          subMenu: true,
          url: 'Label',
          title: 'Label',
        },
        {
          subMenu: true,
          url: 'Caption',
          title: 'Caption',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
      ];
      break;
    case 'components-ios-textfield':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Outline',
          title: 'Outline',
        },
        {
          subMenu: true,
          url: 'Inline',
          title: 'Inline',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Disable',
          title: 'Disable',
        },
        {
          subMenu: true,
          url: 'Icon',
          title: 'Icon',
        },
        {
          subMenu: true,
          url: 'Label',
          title: 'Label',
        },
        {
          subMenu: true,
          url: 'Caption',
          title: 'Caption',
        },
        {
          subMenu: true,
          url: 'Prefix',
          title: 'Prefix',
        },
        {
          subMenu: true,
          url: 'Suffix',
          title: 'Suffix',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
      ];
      break;
    case 'components-ios-accordion':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Line',
          title: 'Line',
        },
        {
          subMenu: true,
          url: 'Icon',
          title: 'Icon',
        },
        {
          subMenu: true,
          url: 'Buttom Line Color',
          title: 'Buttom Line Color',
        },
        {
          subMenu: true,
          url: 'Background Color',
          title: 'Background Color',
        },
        {
          subMenu: true,
          url: 'Font Header',
          title: 'Font Header',
        },
        {
          subMenu: true,
          url: 'Font Family',
          title: 'Font Family',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
        {
          url: 'Example Project',
          title: 'Example Project',
        },
      ];
      break;
    case 'components-ios-tooltip':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Position',
          title: 'Position',
        },
        {
          subMenu: true,
          url: 'Bottom Center',
          title: 'Bottom Center',
        },
        {
          subMenu: true,
          url: 'Bottom Left',
          title: 'Bottom Left',
        },
        {
          subMenu: true,
          url: 'Bottom Right',
          title: 'Bottom Right',
        },
        {
          subMenu: true,
          url: 'Top Center',
          title: 'Top Center',
        },
        {
          subMenu: true,
          url: 'Left',
          title: 'Left',
        },
        {
          subMenu: true,
          url: 'Right',
          title: 'Right',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
        {
          subMenu: true,
          url: 'LGNTooltipBase properties',
          title: 'LGNTooltipBase properties',
        },
        {
          subMenu: true,
          url: 'lgnTooltip view modifier function properties',
          title: 'lgnTooltip view modifier function properties',
        },
        {
          subMenu: true,
          url: 'LGNTooltipIcon properties',
          title: 'LGNTooltipIcon properties',
        },
        {
          url: 'Example Project',
          title: 'Example Project',
        },
      ];
      break;
    case 'components-ios-bottomsheet':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Header',
          title: 'Header',
        },
        {
          subMenu: true,
          url: 'Button Position',
          title: 'Button Position',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
      ];
      break;
    case 'components-ios-chips':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          subMenu: true,
          url: 'Active',
          title: 'Active',
        },
        {
          subMenu: true,
          url: 'Disable',
          title: 'Disable',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
        {
          url: 'Example Project',
          title: 'Example Project',
        },
      ];
      break;
    case 'components-ios-anchor':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
        {
          subMenu: true,
          url: 'With Title',
          title: 'With Title',
        },
        {
          subMenu: true,
          url: 'With centerImage (Without Title)',
          title: 'With centerImage (Without Title)',
        },
      ];
      break;
    case 'components-image-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-image-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Basic',
          title: 'Basic',
        },
        {
          url: 'Image Radius',
          title: 'Image Radius',
        },
        {
          url: 'Image Caching',
          title: 'Image Caching',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
        {
          url: 'References',
          title: 'References',
        },
      ];
      break;
    case 'components-dropdown-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Basic Dropdown',
          title: 'Basic',
          subMenu: true,
        },
        {
          url: 'Dropdown with Icon',
          title: 'with Icon',
          subMenu: true,
        },
        {
          url: 'Dropdown with Description',
          title: 'with Description',
          subMenu: true,
        },
        {
          url: 'Dropdown with Checkbox',
          title: 'with Checkbox',
          subMenu: true,
        },
        {
          url: 'Dropdown with Multiple Categories',
          title: 'with Multiple Categories',
          subMenu: true,
        },
        {
          url: 'Dropdown with Toggle',
          title: 'with Toggle',
          subMenu: true,
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'content-writing-principles':
      heading = [
        {
          url: 'Background',
          title: 'Background',
        },
        {
          url: 'Our Communication',
          title: 'Our Communication',
        },
        {
          url: 'Respect',
          title: 'Respect',
        },
        {
          url: 'Guide',
          title: 'Guide',
        },
        {
          url: 'Encourage',
          title: 'Encourage',
        },
        {
          url: 'Efficient',
          title: 'Efficient',
        },
        {
          url: 'Communication Rules',
          title: 'Communication Rules',
        },
        {
          url: 'Concise',
          title: 'Concise',
        },
        {
          url: 'Empathize',
          title: 'Empathize',
        },
        {
          url: 'Consistent',
          title: 'Consistent',
        },
      ];
      break;
    case 'content-writing-patterns':
      heading = [
        {
          url: 'Thing We Should Know',
          title: 'Thing We Should Know',
        },
        {
          url: 'Titles',
          title: 'Titles',
        },
        {
          url: 'Descriptions',
          title: 'Descriptions',
        },
        {
          url: 'Section Title',
          title: 'Section Title',
        },
      ];
      break;
    case 'content-writing-mechanics':
      heading = [
        {
          url: 'Background',
          title: 'Background',
        },
        {
          url: 'Currency',
          title: 'Currency',
        },
        {
          url: 'date and time',
          title: 'Date & Time',
        },
        {
          url: 'Numbers',
          title: 'Numbers',
        },
        {
          url: 'Phone Number',
          title: 'Phone Number',
        },
        {
          url: 'Measurements',
          title: 'Measurements',
        },
        {
          url: 'temperature coordinate and angle',
          title: 'Temperature, Coordinate, and Angle',
        },
        {
          url: 'File Extensions',
          title: 'File Extensions',
        },
        {
          url: 'Institution',
          title: 'Institution',
        },
        {
          url: 'Cities and Countries',
          title: 'Cities & Countries',
        },
        {
          url: 'URLs',
          title: 'URLs',
        },
      ];
      break;
    case 'content-writing-grammar':
      heading = [
        {
          url: 'Background',
          title: 'Background',
        },
        {
          url: 'Capitalization',
          title: 'Capitalization',
        },
        {
          url: 'Apostrophe',
          title: 'Apostrophe',
        },
        {
          url: 'Quotation Marks',
          title: 'Quotation Marks',
        },
        {
          url: 'Colons',
          title: 'Colons',
        },
        {
          url: 'Commas',
          title: 'Commas',
        },
        {
          url: 'range spans and dashes',
          title: 'Range Spans & Dashes',
        },
        {
          url: 'Ellipses',
          title: 'Ellipses',
        },
        {
          url: 'Periods',
          title: 'Periods',
        },
        {
          url: 'Question Marks',
          title: 'Question Marks',
        },
        {
          url: 'Exclamation Points',
          title: 'Exclamation Points',
        },
        {
          url: 'Pronouns and Referring to Product',
          title: 'Pronouns and Referring to Product',
        },
      ];
      break;
    case 'components-chips-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          subMenu: true,
          url: 'Style',
          title: 'Style',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
      ];
      break;
    case 'components-viewstate-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'How to use',
          title: 'How to use',
        },
        {
          url: 'References',
          title: 'References',
        },
      ];
      break;
    case 'components-radiobutton-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Themes',
          title: 'Themes',
        },
        {
          url: 'Base Components',
          title: 'Base Components',
        },
        {
          url: 'Radio Button Group',
          title: 'Radio Button Group',
        },
        {
          url: 'Radio Button Container',
          title: 'Radio Button Container',
        },
      ];
      break;
    case 'components-chips-guideline':
      heading = [
        {
          url: 'Foundation',
          title: 'Foundation',
        },
        {
          url: 'Container',
          title: 'Container',
        },
        {
          url: 'Padding',
          title: 'Padding',
        },
        {
          url: 'Text label',
          title: 'Text label',
        },
        {
          url: 'Margins',
          title: 'Margins',
        },
        {
          url: 'Placement',
          title: 'Placement',
        },
        {
          url: 'General usage',
          title: 'General usage',
        },
      ];
      break;
    case 'components-datatable-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-datepicker-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Size',
          title: 'Size',
        },
        {
          url: 'DateRange Picker',
          title: 'DateRange Picker',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-megamenu-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-modal-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Basic Modal',
          title: 'Basic',
        },
        {
          subMenu: true,
          url: 'Modal with Content',
          title: 'Modal with Content',
        },
        {
          subMenu: true,
          url: 'Modal with Custom Height and Width',
          title: 'Modal with Custom Height and Width',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-carousel-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Basic Carousel',
          title: 'Basic Carousel',
        },
        {
          url: 'Carousel with Indicator',
          title: 'Carousel with Indicator',
        },
        {
          url: 'Carousel with Subtitle',
          title: 'Carousel with Subtitle',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-tabbar-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Horizontal',
          title: 'Horizontal',
          subMenu: true,
        },
        {
          url: 'Vertical',
          title: 'Vertical',
          subMenu: true,
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-alert-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-chips-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-stepper-website':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Basic',
          title: 'Basic',
        },
        {
          url: 'Props',
          title: 'Props',
        },
      ];
      break;
    case 'components-android-bottomsheet':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Themes',
          title: 'Themes',
        },
        {
          url: 'Properties',
          title: 'Properties',
        },
        {
          url: 'Example',
          title: 'Example',
        },
      ];
      break;
    case 'components-alert-website-v2':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          url: 'Attribute',
          title: 'Attribute',
        },
        {
          subMenu: true,
          url: 'Sub Menu One',
          title: 'Sub Menu One',
        },
        {
          subMenu: true,
          url: 'Sub Menu Two',
          title: 'Sub Menu Two',
        },
        {
          url: 'Example',
          title: 'Example',
        },
      ];
      break;
    case 'components-alert-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Themes',
          title: 'Themes',
        },
        {
          subMenu: true,
          url: 'Alert Button',
          title: 'Alert Button',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
        {
          url: 'Example',
          title: 'Example',
        }
      ];
      break;
    case 'components-badge-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Variant',
          title: 'Variant',
        },
        {
          subMenu: true,
          url: 'Size',
          title: 'Size',
        },
        {
          subMenu: true,
          url: 'Appearance',
          title: 'Appearance',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        },
        {
          url: 'Example',
          title: 'Example',
        }
      ];
      break;
    case 'components-tabbar-android':
      heading = [
        {
          url: 'Usage',
          title: 'Usage',
        },
        {
          url: 'Attributes',
          title: 'Attributes',
        }
      ];
      break;
    default:
      heading = [];
      break;
  }
  return heading;
};

export default HeadingsToc;
